//Node Modules
import { DomElement } from 'html-react-parser';

export const hasName = ({ name }:DomElement, value:string):boolean => name === value
export const hasType = ({ type }:DomElement, value:string):boolean => type === value
export const hasAttrib = ({ attribs }:DomElement, value:string):boolean => attribs !== undefined && attribs[value] !== undefined
export const hasAttribValue = ({ attribs }:DomElement, key: string, value: string):boolean => {
  return !!attribs && attribs[key] === value
}

export const hasAttribValueLike = ({ attribs }:DomElement, key: string, value: RegExp):boolean => {
  return !!attribs && !!attribs[key] && value.test(attribs[key])
}

export const hasClass = ({ attribs }:DomElement, value:string):boolean => {
  const classes = attribs && attribs['class']

  if (classes === undefined) {
    return false
  }

  return classes.split(' ').indexOf(value) !== -1
}

export const headElement = (node:DomElement) => hasName(node, 'head')
export const htmlElement = (node:DomElement) => hasName(node, 'html')
export const bodyElement = (node:DomElement) => hasName(node, 'body')
export const titleElement = (node:DomElement) => {
  let inHeader = node.parent && hasName(node.parent, 'head')
  return inHeader && hasName(node, 'title') ? true : false
}
export const imgElement = (node:DomElement) => hasName(node, 'img')
export const carouselAttrib = (node:DomElement) => hasAttrib(node, 'data-sas-carousel')
export const slideAttrib = (node:DomElement) => hasAttrib(node, 'data-sas-slide')
export const docsetIdVersionAttribs = (node:DomElement) => hasAttrib(node, 'data-docset-id') && hasAttrib(node, 'data-docset-version')
export const xisCasFormatAttribs = (node:DomElement) => hasAttrib(node, 'data-xis-cas-lang')
export const anchorLink = (node:DomElement) =>  node.name === 'a' && !hasAttrib(node, 'data-docset-id') && hasAttribValueLike(node, 'href', /^#/)  